/* global $ */
import React, { useEffect } from "react";
import {Link} from 'react-router-dom'
import PricingCard from './PricingCard'

function DentalPricing() {

  return (
    <section className="pricing-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-7 col-lg-9">
              <div className="section-title text-center mb-65">
                <div className="section-icon"><img src="img/icon/pawprint.png" alt="" /></div>
                <h5 className="sub-title">Price List</h5>
                <h2 className="title">Pet Skin Care Services</h2>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <PricingCard title="skin scraping" price="25" label1="starting at" availability="Monday - Saturday"/>
            <PricingCard title="skin allergy treatment" price="??" label1="Contact us for consultation" availability="Monday - Saturday"/>
          </div>
        </div>
    </section>
  )
}

export default DentalPricing;
